export const IGNORE_BOUNDARIES = 'Ignore Boundaries';

export const NOTE_MODAL_MODE_NOTE = 'note';
export const NOTE_MODAL_MODE_IGNORE_BOUNDARIES = 'ignore_boundaries';